import React, { useEffect, useState } from 'react';
import { Box, Grid, Card, CardContent, Typography, Avatar, Button, useTheme } from '@mui/material';
import Icon1 from '../../img/dashboardImg/rupees.svg'
import Icon2 from '../../img/dashboardImg/Icon.svg'
import Icon3 from '../../img/dashboardImg/Icon1.svg'
import Spotify from '../../img/dashboardImg/Spotify.svg'
import Youtube from '../../img/dashboardImg/Youtube.svg'
import JioSaavan from '../../img/dashboardImg/Jio Saavan.svg'
import YouTubeMusic from '../../img/dashboardImg/Yt Music.svg'
import Gaana from '../../img/dashboardImg/Gaana.svg'
import PlaylistPage from '../dashboardDemo/officalPlaylist'
import { useSelector } from 'react-redux';
import ApiService from '../../_services/ApiService';
import Blog from '../dashboardDemo/Blogs';
import Img from '../../img/dashboardImg/Img.png'
import OfficialImage from '../../img/dashboardImg/Default_Image.png'
import NoResults from '../../components/reusableComponents/NoResults';
import { CardSkeleton, PulsateCardSkeleton, RowCardSkeleton, SmallCardSkeleton } from '../../components/reusableComponents/SkeletonCard';
import ToolCard from '../dashboardDemo/ToolCard'
import { useNavigate } from 'react-router-dom';


const DashboardDemo = () => {
  const { studio_id } = useSelector((s) => s.userData.userData);
  const [cardData, setCardData] = useState([]);
  const [latestRelease, setLatestRelease] = useState([]);
  const [officialPlaylists, setOfficialPlaylists] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [skeleton, setSekeleton] = useState(true)
  const navigate = useNavigate();
  let totalReleases = 0;

  const platformIcons = {
    spotify: Spotify,
    youtube_music: YouTubeMusic,
    gaana: Gaana,
    jiosaavn: JioSaavan,
    youtube: Youtube,
  };

  useEffect(() => {
    if (!studio_id) return;

    const fetchData = async () => {
      try {
        const [albumRes, countRes, playlistRes] = await Promise.all([
          ApiService.get('albumMeta', { limit: 4, offset: 0, song_status: 'Released' }, studio_id),
          ApiService.get('dashboardCount', {}, studio_id),
          ApiService.get('officalPlaylist')
        ]);

        let latestReleases = [];
        // let totalReleases = 0;

        if ([200, 201].includes(albumRes?.status)) {
          const albumResults = albumRes?.data?.results;
          totalReleases = albumRes?.data?.total_count;


          if (albumResults?.items && typeof albumResults.total_count === 'number') {
            latestReleases = albumResults.items;
            // totalReleases = albumResults.total_count;
          }

          else if (Array.isArray(albumResults)) {
            latestReleases = albumResults;
            // totalReleases = albumResults.length;
          }

          setLatestRelease(latestReleases);
        }
        if ([200, 201].includes(playlistRes?.status)) {
          const playlistResults = playlistRes?.data?.results ?? playlistRes?.data;
          const formattedPlaylists = playlistResults.map((playlist) => ({
            image: playlist.playlist_cover_image
              ? `${process.env.REACT_APP_CREATOR_MEDIA_URL}/media/${playlist.playlist_cover_image}`
              : playlist.playlist_cover_image_url
                ? `${process.env.REACT_APP_CREATOR_MEDIA_URL}/media/${playlist.playlist_cover_image_url}`
                : OfficialImage,
            title: playlist.playlist_name,
            slug: playlist.slug,
            privacy_status: playlist.privacy_status,
            platforms: playlist.playlist_releated_platform?.map((platform) => {
              const icon = platformIcons[platform.streamingPlatformKey.toLowerCase()];
              return {
                icon,
                link: platform.streamingPlatformlink
              };
            }).filter(p => p.icon && p.link)
          }));
          setOfficialPlaylists(formattedPlaylists);
        }


        if ([200, 201].includes(countRes?.status)) {
          const countData = countRes?.data;

          const cards = [
            {
              icon: Icon1,
              value: `₹${countData?.revenue_summary?.net_revenue ?? 0}`,
              label: 'Available Balance'
            },
            {
              icon: Icon1,
              value: `₹${countData?.last_payment?.amount_paid ?? 0}`,
              label: 'Last Payout'
            },
            {
              icon: Icon2,
              value: totalReleases,
              label: 'Total Releases'
            },
            {
              icon: Icon3,
              value: `₹${countData?.latest_month_summary?.total_revenue ?? 0}`,
              label: 'Last Month Transaction'
            },
          ];

          setCardData(cards);
        }
      } catch (err) {
        console.error('Dashboard data fetch error:', err);
      } finally {
        setSekeleton(false);
      }

    };


    fetchData();
  }, [studio_id]);


  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch('https://www.groovenexus.com/wp-json/wp/v2/posts/?per_page=10&page=1', {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
          }
        });
        const data = await response.json();

        const mappedBlogs = data?.data?.map((post) => ({
          image: post.featured_image_url || Img,
          title: post.title,
          subtitle: post.content,
          avatar: post.author_avatar.url,
          author: post.author_name,
          date: post.date,
          link: post.link
        }));
        setBlogs(mappedBlogs);
      } catch (err) {
        console.error('Failed to fetch blogs:', err);
      }
    };

    fetchBlogs();
  }, []);




  return (
    <Box minHeight="100vh" sx={{ marginBottom: '20px' }}>
      {/* Stats Section */}
      <Grid container spacing={2} mb={4}>
        {skeleton ?
          [1, 2, 3, 4].map(d => (<RowCardSkeleton />)) : cardData.length ? cardData.map((item, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Card variant="outlined" sx={{ borderRadius: '20px', height: '96px', backgroundColor: '#FFFFFF' }}>
                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: '18px', padding: { xs: '9px 17px', md: '20px 17px' } }}>
                  <Box sx={{ bgcolor: '#F4F7FE', width: '56px', height: '56px', borderRadius: '50%' }}>
                    <Avatar src={item.icon} sx={{ left: '14px', width: '28px', height: '28px', top: '14px' }}>
                      {/* {item.icon} */}
                    </Avatar>
                  </Box>
                  <Box sx={{ paddingLeft: '15px' }}>
                    <Typography sx={{ fontSize: '14px', color: '#A3AED0', fontWeight: 500 }} >{item.label}</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: '#2B3674', fontSize: "24px" }}>{item.value}</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )) : <NoResults />}
      </Grid>

      <Card
        sx={{
          p: { xs: 2, md: 2 },
          background: 'linear-gradient(to right, #111827, #1e3a8a)',
          // background:"#0000007D",
          color: 'white',
          mb: 4,
          borderRadius: '10px',
          gap: { xs: '5px', md: "10px" },
          // height: '127px',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: { xs: "none", sm: 'none', md: 'space-between' },
        }}
      >
        <Box sx={{ paddingLeft: { xs: '0px', md: '20px' } }}>
          <Typography fontWeight={700} sx={{ fontSize: { xs: '16px', sm: '22px', md: '36px' }, maxWidth: { xs: '100%', }, textAlign: 'left' }}>
            Create. Click. Conquer. <br /> Get your song live on all major platforms
          </Typography>
        </Box>
        {/* <Box>
          <Button variant="contained" disabled size='large' sx={{
            backgroundColor: '#ED3237', borderRadius: '8px', marginRight: '30px', "&:hover": {
              backgroundColor: "#ED3237",
            },
          }}>BUY NOW</Button>
        </Box> */}
      </Card>


      <Grid container spacing={2}>
        {/* Latest Releases */}
        <Grid item xs={12} lg={4}>
          <Box sx={{ height: { xs: '100%', md: '485px' }, backgroundColor: '#FFFFFF', padding: '19px 18px ', gap: '20px', borderRadius: '10px' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant='h6' sx={{ fontSize: '20px', color: '#1B2559', fontWeight: 500 }}>Latest Releases</Typography>
              <Button size="small" onClick={(e) => navigate('/releasealbum')} sx={{ width: '78px', height: '32px', color: '#4318FF', backgroundColor: '#F4F7FE', textTransform: "capitalize", borderRadius: '35px', fontSize: '14px' }}>See all</Button>
            </Box>
            <Grid container spacing={2}>
              {/* {console.debug("latestrelease", latestRelease)} */}
              {skeleton ?
                [1, 2, 3, 4].map(d => (<SmallCardSkeleton key={d} />))
                :
                latestRelease.length ? latestRelease.map((release, i) => (
                  <Grid item xs={12} key={i}>
                    {/* {console.debug("Latest Release" ,release )} */}
                    <Card variant="outlined" sx={{ backgroundColor: "#FFFFFF", height: '86px', gap: '10px', border: '1px solid #F4F4F4', borderRadius: '10px' }}>
                      <CardContent sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <Box sx={{ borderRadius: '8px', width: '56px', height: '56px' }}>
                          <img src={
                            release.cover_image
                              ? `${process.env.REACT_APP_SONGAPIURL_MEDIA}/media/${release.cover_image}`
                              : ''
                          } alt={release.album_name?.substring(0, 4)} style={{ borderRadius: '8px', width: '100%', height: '100%', objectFit: 'cover' }} />
                        </Box>
                        <Box flexGrow={1}>
                          <Typography fontWeight={600} sx={{ color: '#1B2559', fontSize: '16px' }}>{release.album_name}</Typography>
                          <Typography variant="body2" sx={{ color: '#A3AED0', fontSize: '14px' }}>
                            {release?.primary_artists[0].artist_name}
                          </Typography>
                        </Box>
                        {/* <Typography variant="caption" sx={{ color: '#A3AED0', fontSize: '14px' }}>30s ago</Typography> */}
                      </CardContent>
                    </Card>
                  </Grid>
                )) : <NoResults />}
            </Grid>
          </Box>
        </Grid>

        <Grid item xs={12} lg={8}>
          <PlaylistPage playlistItems={officialPlaylists} skeleton={skeleton} />
        </Grid>

        <Grid item xs={12} lg={9}>
          <Blog Blogs={blogs} skeleton={skeleton} />
        </Grid>

        <Grid item xs={12} lg={3}>
          <ToolCard />
        </Grid>
      </Grid>

    </Box>
  );
};

export default DashboardDemo;
